import { Environment } from "Constants/constants";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { CartPartnerTypes } from "Store/partners/partnerInterfaces";
import { EditProductURL } from "Store/texts/hooks";

export const productName = INSURANCE_NAME_VALUE.CHILD;
export const cartId = "C-1234";
export const productId = "P-1234";
export const partner = "afag";
const oldUrl = "oldProductUrl";
const newUrl = "newProductUrl";

export const environments = {
  PROD: { env: Environment.PRODUCTION, origin: "www.storebrand.no" },
};

export const expectedOutputs = {
  checkPrice: `/sjekk-pris/${newUrl}?cartId=${cartId}&productId=${productId}`,
  checkPriceWithPartner: `/sjekk-pris/${newUrl}?grp=${partner}&cartId=${cartId}&productId=${productId}`,
};

export const getProductURLs = (): Record<string, EditProductURL> => ({
  ADVICE: {
    oldUrl,
    newUrl,
  },
  CAR: {
    oldUrl,
    newUrl,
  },
  CHILD: {
    oldUrl,
    newUrl,
  },
  ELECTRIC_SCOOTER: {
    oldUrl,
    newUrl,
  },
});

export interface ToggleData {
  productName: INSURANCE_NAME_VALUE;
  cartPartner: CartPartnerTypes;
  isPartnerToggled: boolean;
}

export interface UrlData {
  productURL: EditProductURL;
  cartId: string;
  productId: string;
}

export type GetEditUrl = (toggleData: ToggleData, urlData: UrlData) => string;
